export { default } from "./ContentDisplayEyebrow";
